const map = {
	"./1.jpg": "./src/assets/images/user/1.jpg",
	"./10.jpg": "./src/assets/images/user/10.jpg",
	"./11.png": "./src/assets/images/user/11.png",
	"./12.png": "./src/assets/images/user/12.png",
	"./14.png": "./src/assets/images/user/14.png",
	"./16.png": "./src/assets/images/user/16.png",
	"./2.jpg": "./src/assets/images/user/2.jpg",
	"./2.png": "./src/assets/images/user/2.png",
	"./3.jpg": "./src/assets/images/user/3.jpg",
	"./3.png": "./src/assets/images/user/3.png",
	"./4.jpg": "./src/assets/images/user/4.jpg",
	"./5.jpg": "./src/assets/images/user/5.jpg",
	"./6.jpg": "./src/assets/images/user/6.jpg",
	"./7.jpg": "./src/assets/images/user/7.jpg",
	"./8.jpg": "./src/assets/images/user/8.jpg",
	"./9.jpg": "./src/assets/images/user/9.jpg",
	"./user-dp.png": "./src/assets/images/user/user-dp.png",
	"./user.png": "./src/assets/images/user/user.png"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/user sync recursive ^\\.\\/.*$";